import i18next from 'i18next';
import { bool, string } from 'prop-types';
import { useHistory } from 'react-router';
import { Lock } from 'lucide-react';
import cn from 'classnames';

import { Button } from '#basicComponents/shadcn/button';
import { ROUTES } from '#constants/routes';
import { ROLES } from '#constants/users';
import { getNoAccessPath } from '#models/routes';

import './i18n';

// Blocks the current screen (same overlay as PremiumFeatureGate) when the free trial or the subscription of the
// workspace is over. Only the owner can subscribe.
const SubscriptionGate = ({ role, withMenu }) => {
  const { push } = useHistory();
  const isOwner = role === ROLES.OWNER;

  return (
    <div
      className={cn(
        'fixed inset-y-0 right-0 z-40 bg-black/10 backdrop-blur-sm',
        withMenu ? 'left-20' : 'left-0'
      )}>
      <div className="flex h-full w-full items-center justify-center">
        <div className="w-full max-w-sm space-y-4 rounded-lg border border-neutral-200 bg-white p-6 shadow-lg">
          <div className="flex flex-col items-center gap-2 text-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-200/30">
              <Lock className="h-7 w-7 text-amber-400" />
            </div>
            <span className="text-xl font-semibold">{i18next.t('SubscriptionGate:title')}</span>
            <span className="text-sm text-neutral-500">
              {i18next.t(`SubscriptionGate:${isOwner ? 'description' : 'adminDescription'}`)}
            </span>
          </div>
          <div className="flex flex-col gap-2">
            {isOwner && (
              <Button onClick={() => push(ROUTES.SUBSCRIPTION_PLANS.path)}>
                {i18next.t('SubscriptionGate:seePlans')}
              </Button>
            )}
            <Button variant="outline" onClick={() => push(getNoAccessPath(role))}>
              {i18next.t('SubscriptionGate:goToWorkspace')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

SubscriptionGate.propTypes = {
  role: string,
  withMenu: bool
};

export default SubscriptionGate;
